import React, { useState, useEffect } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Typography from "@material-ui/core/Typography";
import { TextField } from "@material-ui/core";
// import Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
// import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";
// import LoadderButton from "../../Layouts/LoadderButton";
import AuthApi from "../../Services/Authapi";
// import Paper from "@material-ui/core/Paper";
// import FontAwesomeIconComponent from "../../Layouts/FontAwesomeIconComponent";
// import { SignalCellularNull } from "@material-ui/icons";
// import Authapi from "../../Services/Authapi";
// import swal from "sweetalert";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
// import { now } from "moment";
import moment from "moment";
import ls from "local-storage";
import AuthCheckComponent from "../../Layouts/Token";
import swal from "sweetalert";

const inileaves = {
  leaveType: "",
  ticketMesasge: "",
  dateRange: "",
  firstleavetype: "",
  secondleavetype: "",
  startDate: "",
  endDate: "",
  leaveStatus: "",
  cancel_reason: "",
  ticket_Id: 0,
};

const EditTicket = (props) => {
  const classes = props;
  const [editValues, setEditValues] = useState(inileaves);
  const [formErrors, setFormErrors] = useState({});

  const parseDateInput = (value) => {
    if (!value) {
      return null;
    }

    const parsedDate = moment(value, [
      moment.ISO_8601,
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "YYYY-M-D",
      "YYYY/M/D",
      "MM/DD/YYYY",
      "M/D/YYYY",
      "MM-DD-YYYY",
      "M-D-YYYY",
      "DD/MM/YYYY",
      "D/M/YYYY",
      "DD-MM-YYYY",
      "D-M-YYYY",
    ], true);

    return parsedDate.isValid() ? parsedDate : null;
  };

  const normalizeDateInput = (value) => {
    const parsedDate = parseDateInput(value);
    return parsedDate ? parsedDate.format("YYYY-MM-DD") : value;
  };

  const getComparableDate = (value) => {
    const parsedDate = parseDateInput(value);
    return parsedDate && parsedDate.year() >= 1000 ? parsedDate : null;
  };

  const extractDateRange = (
    dateRange,
    fallbackStartDate = "",
    fallbackEndDate = ""
  ) => {
    let rangeValues = [];

    if (Array.isArray(dateRange)) {
      rangeValues = dateRange;
    } else if (typeof dateRange === "string") {
      const trimmedDateRange = dateRange.trim();

      if (trimmedDateRange.startsWith("[") && trimmedDateRange.endsWith("]")) {
        try {
          const parsedDateRange = JSON.parse(trimmedDateRange);
          if (Array.isArray(parsedDateRange)) {
            rangeValues = parsedDateRange;
          }
        } catch (error) {
          rangeValues = [];
        }
      }

      if (rangeValues.length === 0 && trimmedDateRange) {
        rangeValues = trimmedDateRange.split(/\s+[Tt][Oo]\s+/);
      }

      if (rangeValues.length === 0 && trimmedDateRange) {
        rangeValues = [trimmedDateRange];
      }
    } else if (dateRange && typeof dateRange === "object") {
      rangeValues = [
        dateRange.startDate ||
          dateRange.start_date ||
          dateRange.from ||
          dateRange[0],
        dateRange.endDate ||
          dateRange.end_date ||
          dateRange.to ||
          dateRange[1],
      ];
    }

    const normalizedStartDate = normalizeDateInput(
      rangeValues[0] || fallbackStartDate || ""
    );
    const normalizedEndDate = normalizeDateInput(
      rangeValues[1] || fallbackEndDate || rangeValues[0] || fallbackStartDate || ""
    );

    return {
      startDate: normalizedStartDate || "",
      endDate: normalizedEndDate || "",
    };
  };

  const getDateFieldError = (name, value, values = editValues) => {
    const trimmedValue = value ? value.trim() : "";

    if (!trimmedValue) {
      return "";
    }

    const selectedDate = getComparableDate(trimmedValue);
    if (!selectedDate) {
      return "Invalid date";
    }

    const currentDate = moment().startOf("day");
    if (selectedDate.isBefore(currentDate, "day")) {
      return "Date cannot be before the current date";
    }

    if (name === "startDate") {
      const parsedEndDate = getComparableDate(values.endDate);
      if (parsedEndDate && selectedDate.isAfter(parsedEndDate, "day")) {
        return "Start date cannot be after end date";
      }
    }

    if (name === "endDate") {
      const parsedStartDate = getComparableDate(values.startDate);
      if (parsedStartDate && selectedDate.isBefore(parsedStartDate, "day")) {
        return "End date cannot be before start date";
      }
    }

    return "";
  };

  const buildTicketPayload = (values) => {
    const startDate = normalizeDateInput(values.startDate);
    const endDate = normalizeDateInput(values.endDate);
    const a = getComparableDate(startDate);
    const b = getComparableDate(endDate);
    let noOfDays = 0;

    if (
      values.firstleavetype === "first-half" &&
      values.secondleavetype === "first-half"
    ) {
      noOfDays = 0.5;
    } else if (
      values.firstleavetype === "second-half" &&
      values.secondleavetype === "second-half"
    ) {
      noOfDays = 0.5;
    } else {
      noOfDays = a && b ? b.diff(a, "days") + 1 : 0;
    }

    return {
      ...values,
      dateRange: [startDate, endDate],
      noOfDays,
    };
  };

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push("/login");
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Check if the field being changed is a date field
    if (name === "startDate" || name === "endDate") {
      const nextValues = { ...editValues, [name]: value };
      const nextErrors = { ...formErrors };

      const currentFieldError = getDateFieldError(name, value, nextValues);
      if (currentFieldError) {
        nextErrors[name] = currentFieldError;
      } else {
        delete nextErrors[name];
      }

      const linkedFieldName = name === "startDate" ? "endDate" : "startDate";
      const linkedFieldValue = nextValues[linkedFieldName];
      if (linkedFieldValue) {
        const linkedFieldError = getDateFieldError(
          linkedFieldName,
          linkedFieldValue,
          nextValues
        );

        if (linkedFieldError) {
          nextErrors[linkedFieldName] = linkedFieldError;
        } else {
          delete nextErrors[linkedFieldName];
        }
      }

      setEditValues(nextValues);
      setFormErrors(nextErrors);
      return;
    }

    setEditValues({ ...editValues, [name]: value });
  };

  // function dateDiffInDays(startDate, endDate) {
  //     // round to the nearest whole number
  //     return Math.round((endDate - startDate) / (1000  60  60 * 24));
  // }
  // const daysDiff = dateDiffInDays(new Date(editValues.startDate), new Date(editValues.endDate));
  // const dsp = dateDiffInDays(new Date(), new Date(editValues.startDate));

  const validate = (values) => {
    let errors = {};
    const regex = /^[a-zA-Z]/;
    // const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

    // if (!values.leaveType) {
    //     errors.leaveType = "Cannot be blank";
    // } else if (!regex.test(values.leaveType)) {
    //     errors.leaveType = "Invalid firstName format";
    // }

    // if (!values.ticketMesasge) {
    //     errors.ticketMesasge = "Cannot be blank";
    // } else if (!regex.test(values.ticketMesasge)) {
    //     errors.ticketMesasge = "Invalid ticketMesasge format";
    // }

    // if (!values.startDate) {
    //     errors.startDate = "Cannot be  blank";
    // } else if (!dateR.test(values.startDate)) {
    //     errors.startDate = "Invalid dob format"
    // }
    // else {

    //     if (dsp < 0) {
    //         errors.startDate = "you can chooes only Current and future Date";

    //     }
    // }

    // if (!values.endDate) {
    //     errors.endDate = "Cannot be  blank";
    // } else if (!dateR.test(values.endDate)) {
    //     errors.endDate = "Invalid dob format"
    // } else {

    //     if (daysDiff < 0) {
    //         errors.endDate = "you can chooes only Current and future Date";

    //     }
    // }

    if (!values.leaveStatus) {
      errors.leaveStatus = "Cannot be blank";
    } else if (!regex.test(values.leaveStatus)) {
      errors.leaveStatus = "Invalid firstName format";
    }

    if (!values.startDate) {
      errors.startDate = "Cannot be blank";
    } else {
      const startDateError = getDateFieldError("startDate", values.startDate, values);
      if (startDateError) {
        errors.startDate = startDateError;
      }
    }

    if (!values.endDate) {
      errors.endDate = "Cannot be blank";
    } else {
      const endDateError = getDateFieldError("endDate", values.endDate, values);
      if (endDateError) {
        errors.endDate = endDateError;
      }
    }

    return errors;
  };

  const getTicketData = async () => {
    let ticketId =
      props.history.location.pathname.split("/")[
      props.history.location.pathname.split("/").length - 1
      ];
    let ticket = await AuthApi.singleTicket(ticketId);
    let ticket_Id = ticketId;
    const ticketData =
      ticket && ticket.status === true && ticket.data && ticket.data[0]
        ? ticket.data[0]
        : null;

    let leaveType =
      ticketData &&
      ticketData.leaveType &&
      (ticketData.leaveType !== null || ticketData.leaveType !== false)
        ? ticketData.leaveType
        : "";
    let ticketMesasge =
      ticketData && ticketData.ticket_mesasge
        ? ticketData.ticket_mesasge
        : "";
    let firsthalf =
      ticketData && ticketData.firstleavetype
        ? ticketData.firstleavetype
        : "";

    let secondhalf =
      ticketData && ticketData.secondleavetype
        ? ticketData.secondleavetype
        : "";
    let Status =
      ticketData && ticketData.status
        ? ticketData.status
        : "";
    const { startDate, endDate } = extractDateRange(
      ticketData && ticketData.date_range ? ticketData.date_range : null,
      ticketData && (ticketData.startDate || ticketData.start_date)
        ? ticketData.startDate || ticketData.start_date
        : "",
      ticketData && (ticketData.endDate || ticketData.end_date)
        ? ticketData.endDate || ticketData.end_date
        : ""
    );

    setEditValues({
      ...inileaves,
      leaveType: leaveType,
      ticketMesasge: ticketMesasge,
      firstleavetype: firsthalf,
      secondleavetype: secondhalf,
      startDate: startDate,
      endDate: endDate,
      leaveStatus: Status,
      ticket_Id: ticket_Id,
    });
  };

  useEffect(() =>{ setTimeout(() => getTicketData(), 500)}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate(editValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
       editTickets();
    }
  };

  // function diffday() {
  //   const a = moment(editValues.startDate);
  //   const b = moment(editValues.endDate);
  //   const dateRangeArr = [];

  //   var startDate = editValues.startDate;
  //   dateRangeArr.push(startDate);

  //   var endDate = editValues.endDate;
  //   dateRangeArr.push(endDate);

  //   editValues.dateRange = dateRangeArr;
  //   editValues.noOfDays = b.diff(a, "days")+ 1;
  // }
 


  // const editTickets = async (id) => {
  //   let status = await AuthApi.updateTicket(editValues, editValues.ticket_Id);

  //   if (status && status.status === true) {
  //     props.history.push("/tickets");
  //   }
  // };

  const editTickets = async (id) => {
    const payload = buildTicketPayload(editValues);
    let status = await AuthApi.updateTicket(payload, editValues.ticket_Id);

    if (status && status.status === true) {
        // Success popup
        swal("Success!", "Your ticket has been updated.", "success");
        props.history.push("/leave-tickets");
    } else {
        // Error handling: Show error message from the API response
        const errorMessage = status && status.message ? status.message : "There was an issue updating your ticket.";
        swal("Error!", errorMessage, "error");
    }
};

// ... existing code ...
// ... existing code ...

  // console.log(editValues);
  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <Card className={classes.root} style={{ marginBottom: "3%" }}>
              <CardContent>
                <Breadcrumb
                  {...props}
                  primaryPageName="Leaves Ticket"
                  primaryPageLink="/leave-tickets"
                  isSecondaryPage={true}
                  secondaryPageName="edit"
                />
              </CardContent>
            </Card>

            <Grid container className={classes.root} spacing={2}>
              <Grid item xs={12}>
                <Card className={classes.root}>
                  <CardContent>
                    <Typography variant="h2">Edit Ticket</Typography>

                    <form className={classes.form} onSubmit={handleSubmit}>
                      <Grid container className={classes.root} spacing={5}>
                        <Grid item xs={12}>
                          <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                            disabled={[
                              ls("roles") === "Super Admin" ? false : true,
                            ]}
                          >
                            <InputLabel id="demo-simple-select-outlined-label">
                              Leave-Type
                            </InputLabel>

                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="leave-Type"
                              name="leaveType"
                              disabled={
                                ls("roles") === "Super Admin" ? true : false
                              }
                              value={
                                editValues && editValues.leaveType !== null
                                  ? editValues.leaveType
                                  : ""
                              }
                              className={formErrors.leaveType && "input-error"}
                              onChange={handleChange}
                            >
                              <MenuItem value="Loss Of Pay">
                                Loss Of Pay
                              </MenuItem>
                              {/* <MenuItem value="Casual Leave">
                                Casual Leave
                              </MenuItem> */}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            id="date"
                            variant="outlined"
                            disabled={
                              ls("roles") === "Super Admin" ? true : false
                            }
                            label="Start-date"
                            name="startDate"
                            type="date"
                            value={editValues.startDate || ""}
                            onChange={handleChange}
                            error={Boolean(formErrors.startDate)}
                            helperText={formErrors.startDate}
                            className={`${classes.textField} ${formErrors.startDate ? "input-error" : ""}`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              max: editValues.endDate || undefined,
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                          >
                            <InputLabel id="demo-simple-select-outlined-label">
                              Select-Half
                            </InputLabel>
                            {/* {console.log("First Leave Type:", editValues.firstleavetype)}
                            {console.log("Second Leave Leave Type:", editValues.secondleavetype)} */}

                            <Select
                              labelId="demo-simple-select-outlined-label"
                              disabled={
                                ls("roles") === "Super Admin" ? true : false
                              }
                              id="demo-simple-select-outlined"
                              name="firstleavetype"
                              // error={formErrors.leaveType && true}
                              value={
                                editValues && editValues.firstleavetype !== null
                                  ? editValues.firstleavetype
                                  : null
                              }
                              className={
                                formErrors.firstleavetype && "input-error"
                              }
                              onChange={handleChange}
                            >
                              <MenuItem value="first-half">First Half</MenuItem>
                              <MenuItem value="second-half">
                                Second Half
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            id="date"
                            variant="outlined"
                            label="End-date"
                            name="endDate"
                            type="date"
                            disabled={
                              ls("roles") === "Super Admin" ? true : false
                            }
                            value={editValues.endDate || ""}
                            onChange={handleChange}
                            error={Boolean(formErrors.endDate)}
                            helperText={formErrors.endDate}
                            className={`${classes.textField} ${formErrors.endDate ? "input-error" : ""}`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              min: editValues.startDate || undefined,
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                          >
                            <InputLabel id="demo-simple-select-outlined-label">
                              Select-Half
                            </InputLabel>
                            <Select
                              disabled={
                                ls("roles") === "Super Admin" ? true : false
                              }
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="Select-Half"
                              name="secondleavetype"
                              value={
                                editValues &&
                                  editValues.secondleavetype !== null
                                  ? editValues.secondleavetype
                                  : ""
                              }
                              onChange={handleChange}
                            >
                              <MenuItem value="first-half">First Half</MenuItem>
                              <MenuItem value="second-half">
                                Second Half
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            id="ticketMesasge"
                            name="ticketMesasge"
                            label="Reason for Leave"
                            variant="outlined"
                            disabled={
                              ls("roles") === "Super Admin" ? true : false
                            }
                            onChange={handleChange}
                            value={
                              editValues && editValues.ticketMesasge !== null
                                ? editValues.ticketMesasge
                                : null
                            }
                            className={
                              formErrors.ticketMesasge && "input-error"
                            }
                          />
                        </Grid>

                        {/* <Grid item xs={3}>
                          <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                            disabled={
                              ls("roles") === "Super Admin" ? false : true
                            }
                          >
                            <InputLabel id="demo-simple-select-outlined-label1">
                              Leave-Status
                            </InputLabel>
                            <Select
                              autoFocus
                              labelId="demo-simple-select-outlined-label1"
                              id="demo-simple-select-outlined1"
                              disabled={
                                ls("roles") === "Super Admin" ? false : true
                              }
                              label="leave-status"
                              name="leaveStatus"
                              error={formErrors.leaveStatus && true}
                              value={
                                editValues && editValues.leaveStatus !== null
                                  ? editValues.leaveStatus
                                  : ""
                              }
                              focused={
                                editValues && editValues.leaveStatus !== null
                                  ? true
                                  : false
                              }
                              onChange={handleChange}
                              className={
                                formErrors.leaveStatus && "input-error"
                              }
                            >
                              <MenuItem value="pending">Pending</MenuItem>
                              <MenuItem value="approved">Approved</MenuItem>
                              <MenuItem value="declined">Declined</MenuItem>
                              <MenuItem value="canceled">Canceled</MenuItem>
                            </Select>
                          </FormControl>
                          {formErrors.leaveStatus && (
                            <span className="error">
                              {formErrors.leaveStatus}
                            </span>
                          )}
                        </Grid> */}
                      </Grid>

                      <Grid container className={classes.root} spacing={3}>
                        <Grid item xs={4} style={{ display: "flex" }}>
                          <Button
                            type="submit"
                            style={{ marginTop: "10px" }}
                            variant="contained"
                            color="primary"
                          >
                            Edit
                          </Button>
                          <Button
                            type="button"
                            style={{ marginTop: "10px" }}
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/leave-tickets");
                            }}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}></Grid>
            </Grid>
          </div>
        }
      />
      <Footer />
    </div>
  );
};

export default EditTicket;
